module.exports = __webpack_public_path__ + "img/ionicAngular.8678d535.png";